export default {"src":"/_next/static/media/assurance-civile.fb88ef54.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};